export default class FacebookService {
    constructor() {
        this.fbAppId = fbAppId;
        this.fbApiVersion = 'v8.0';
    }

    init() {
        window.fbAsyncInit = () => {
            FB.init({
                appId      : this.fbAppId,
                xfbml      : true,
                version    : this.fbApiVersion
            });
        };
        
        // snippet from fb
        (function(d, s, id){
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {return;}
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    }

    getPages(callback) {
        FB.api('me/accounts', callback || (function(){}));
    }

    login(callback, scopes = []) {
        const permissions = scopes.length
            ? scopes
            : ['pages_manage_metadata', 'leads_retrieval', 'pages_read_engagement', 'business_management']

        FB.login(callback || (function(){}), {scope: permissions});
    }

    subscribeApp(pageId, accessToken, callback) {
        FB.api(
            '/' + pageId + '/subscribed_apps',
            'post',
            { subscribed_fields: 'leadgen', access_token: accessToken },
            callback
        );
    }

    getAdAccounts(accessToken) {
        return FB.api(
            '/me/adaccounts?fields=business,name',
            accessToken
        );
    }

    unsubscribeApp(pageId, accessToken, callback) {
        FB.api(
            '/' + pageId + '/subscribed_apps',
            'delete',
            { subscribed_fields: 'leadgen', access_token: accessToken },
            callback
        );
    };
}
